const testPlatform = (regExp: RegExp) => {
  return regExp.test(window.navigator.userAgentData?.platform ?? window.navigator.platform);
};

export const getIsIos = () => {
  // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support
  return testPlatform(/^iPhone/i) || testPlatform(/^iPad/i) || (testPlatform(/^Mac/i) && window.navigator.maxTouchPoints > 1);
};
